import script from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"

import "./RestoreAccountView.vue?vue&type=style&index=0&id=50a29c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a29c00"]])

export default __exports__